// extracted by mini-css-extract-plugin
export default {"container":"NoInternetConnection_container__DtU9f","icon":"NoInternetConnection_icon__0vzVK","text":"NoInternetConnection_text__FjY5Y"};